export enum PauseReasonEnum {
  User = 'User',
  Idle = 'Idle',
  Safe = 'Safe',
  External = 'External'
}
